"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var $scrollDownBtn = $('.scrolldown-header__scrollDownBtn'), $smartBadges = $('.smart-integrations-features');
    var scrollDown = function () {
        var badgesHeight = $smartBadges.offset().top;
        $(window).scrollTop(badgesHeight);
    };
    var enableEvents = function () {
        $scrollDownBtn.on('click', scrollDown);
    };
    enableEvents();
};
exports.init = init;
